module.exports = __webpack_public_path__ + "img/workspace.0af6046f.svg";